export const MelanauHandiList = [
  {
    name: "Jengayak Tina",
    img_src: "https://66.media.tumblr.com/d72123f69fd78be3dbd28ea22d860aa9/f4ef3ad1d14ccd9f-63/s540x810/2dd5dcd283da69b0f7150c975d9ca69162da1fdb.png",
    description: "'Jengayak' or 'Sayag' is a human figure relic crafted from young nipah leaves. There are two types of 'Jengayak' : 'Jengayak Tina' and 'Jengayak Anek'. 'Jengayak Tina' is placed on the deceased's chest and is eventually brought to the cemetery and placed on the raised grave. It is used to guide the deceased's soul to the afterworld.", 
    url: "jengayak-tina"
  },

  {
      name:"Jengayak Anek",
      img_src: " ",
      description:"'Jengayak' or 'Sayag' is a human figure relic crafted from young nipah leaves. There are two types of 'Jengayak': 'Jengayak Tina' and 'Jengayak Anek'. 'Jengayak Anek' is the type that is not taken to the cemetery but instead is placed at home to console and comfort the family in any unwanted event. ",
      url:"jengayak-anek"
  }, 

  {
      name:"Bunga Tepasik",
      img_src: "https://66.media.tumblr.com/0121261a63fb49cb01dd24594b1d72fd/ad5cf72e564ac468-a2/s540x810/b286570933f552a38d039cc636c1f3891e88e0a6.png",
      description: "The Bunga Tepasik or wild orchid weave is one the ornaments needed on the 'Seraheng', a decorated flat basket) is filled with offering for spirits and raised on a bamboo pole during the Kaul. It is intricately braided with nipa leaves. The process of making the ornaments and consequently, the 'Seraheng' requires certain skills being passed from generations to generations.",
      url:"bunga-tepasik", 
      source:" facebook"
  }, 

  {
      name: "Pok Buak Runong",
      img_src:"https://66.media.tumblr.com/c11effb88673032ea35e2f8d66ba75c5/ad5cf72e564ac468-21/s540x810/165fa7f778db16acb253df88a5c2ae46f3893b7d.png",
      description:"Pok Buak Runong is one of the ornaments in a healing ceremony, 'Payun Peseladai'. It is usually hange under a rattan swing, 'Ayun Wai', and 'Ayun Asok', a swing with dragon motif. 'Gerunong' was inserted into the woven ornament whereby it would make a sound every time the witchdoctor or the patient sat on the swing.", 
      url:"pok-buak-runong", 
      source : "facebook "
  },

  {
      name:"Tapow", 
      img_src: "https://66.media.tumblr.com/319c115d00bf0d59cc9e3379230ae172/ad5cf72e564ac468-6a/s540x810/b31c57b5cc633f9be8805b7a36ac2b902c909c8c.png", 
      description: "Tapow is a traditional Melanau headgear usually worn by women. The conical-shaped sunhat is made from sago palm strips and leaves, and reinforced with rattan strips. The intricate and elaborate design of this piece of handicraft adds a sense of style to its wearer.",
      url:"tapow"
  }, 

  {
      name: "Terendak",
      img_src: "https://66.media.tumblr.com/396e78fee3d041ff5b589a7d4c59017a/cde0cbbdff35659a-cb/s540x810/4cca8cf4e3b94a85bf3baebc8b56789e3d47b2d4.png",
      description:"Terendak by definition is a head or a conical-shaped head cover. Traditionally, the  Terendak is made out of nipah leaves, bamboo or rattan. The process of crafting the Terendak is not as easy as it seems at it would require a certain weaving skill in order to make a beautiful Terendak. This piece of handicraft was worn by the fishermen as they were sailing to the sea.",
      url:"terendak" , 
      source: "facebook"
  },
];

export const MelanauAgriList = [
  {
    name: "Penapis",
    img_src: "https://66.media.tumblr.com/077ae9f771aab8a7aa0c88c81c1e7d47/ad5cf72e564ac468-b4/s540x810/b55007f3eb6325e42111a823270148d1fc9ff0ec.png",
    description: "Penapis is a sieve made of tree bark while the handle is made of wood. It is used to filter water.", 
    url: "Penapis"
  },
  {
      name:"Penampi",
      img_src: "https://66.media.tumblr.com/ae1f1ec111e21877cb6c950a1bf9dc99/ad5cf72e564ac468-e4/s540x810/12e4a9aaaec6e5f2b8e65dca831b9a6ce201b435.png" , 
      description:"“Penampi”  is woven from nipah leaves and its frame is made by rattan. The “Penampi” is used to sift paddy.",
      url:"Penampi"

  },

  {
      name: "Takuong",
      img_src:"https://66.media.tumblr.com/daa5dbe82c358d4a7d705d21a3b952d2/f4ef3ad1d14ccd9f-1b/s540x810/6f37198a881cb25713bb446d77dcb66368b55e14.png",
      description:"“Takuong” is a woven sifter.  It comes in different design which then serves distinct purpose. The picture above is a form of “Takuong” used by the people to put their fishing catch into. The way this artefact is woven helps to strain water. ",
      url:"takuong"
  },

  {
      name: "Baken",
      img_src: "https://66.media.tumblr.com/59c3f9699ccef9ac090333919bec4a3b/f4ef3ad1d14ccd9f-76/s540x810/13ef7648fded5d39a087ec4100ec6223815b5ea0.png",
      description:" 'Baken' is an object to carry harvested fruits or produce.",
      url :"baken"
  },


];

export const MelanauToolsList = [
  {   
      name: "Dapur Lama",
      img_src: "https://66.media.tumblr.com/11f05df0ff248037226dd51473b8fe70/72033a24f9d4fd5c-53/s540x810/4ee02edf9673c39683cabc44d25c632a2b20b09d.png",
      description:"“Dapur lama” can literally be translated as a traditional kitchen. The picture depicts a place for cooking with firewood. ",
      url: "Dapur-Lama"
  },

  {
      name: "Kayu Belian",
      img_src:"https://66.media.tumblr.com/7e02a52d1cdd981d236024cc185bf209/72033a24f9d4fd5c-d1/s540x810/a91fa40af582cab28f2e3fa682159ddca2869b96.png",
      description:"Kayu Belian is a piece of wood that came from Belian tree. It is exceptionally sturdy to a point that it could act as a pestle to grind paddy seeds.",
      url:"Kayu-Belian"
  },

  {
      name:"Tempayan",
      img_src:"https://66.media.tumblr.com/dc665e2564e5216922b94b381df5e49f/ad5cf72e564ac468-f3/s540x810/015e8fd9d506ad211fbaf4580c055a1f40dce335.png",
      description:"“Tempayan” can be literally translated as a storing vessel. Other than its function to store water, the “Tempayan” is also used to store skeletal remains within the “Jerunei”. ",
      url:"Tempayan"
  },

  {
      name:"Tepak Sirih",
      img_src:"https://66.media.tumblr.com/f19bb67d98247572a7e43a2964ac4dda/ad5cf72e564ac468-53/s540x810/cd3ed98b940681c145f3ab512d79d7823c2042a2.png",
      description:"“Tepak Sirih” is a carven wooden box used to keep the betel leaf (daun sirih) /areca palm (buah pinang) / herbs. The wood used to make the “Tepak Sirih” is usually sturdy and hard as to ensure that it is not easy for termites to eat it. ",
      url:"tepak-sirih"
  },

  {
      name: "Mangkuk Dulang",
      img_src:"https://66.media.tumblr.com/d9d1dd01b04458f9b7f9ce7458da00f0/ad5cf72e564ac468-f9/s540x810/733e0e49aa549fa79830a8df555f014f7c8be744.png",
      description:"“Mangkuk dulang” is a tray made out of silver and a popular decoration in every home. Usually placed on the wall of the house in the living room. ",
      url:"mangkuk-dulang"
  },

  {
      name:"Bekas Kayu / Bi'taeng",
      img_src:"https://66.media.tumblr.com/f12cc875e5dfc494b85b9b0c589b9427/513bd3b28454b024-cd/s540x810/c21a9a809ecf3618108493dd84f089d57e4c2ef4.png",
      description:"“Bekas Kayu” or Bi'taeng is a wooden kitchenware used to keep food. The Bekas Kayu comes with a cover as to keep the food away from insects or ants. ",
      url:"bekas-kayu"
  }, 

  {
      name: "Mejak / Jak",
      img_src:"https://66.media.tumblr.com/a105f43167e4b0ac7691060585f16c34/3cb1841f8c84fc7c-1f/s540x810/77fe9fd485a0d79093b5ba391485a75e48349a77.png",
      description:"One of the traditions being practiced long time ago was forehead flattening. Mejak / Jak is the tool used for that process. This tool would be placed on the forehead of 2 weeks old babies with the intention that when they got married one day, they would look beautiful in the “Serbang”. ",
      url:"mejak-jak"
  },

]; 

export const MelanauOthersList = [
  {
      name: "Teko Lama",
      img_src: "https://66.media.tumblr.com/3b29549676a17f46490f06130d0619fc/72033a24f9d4fd5c-ab/s540x810/c961e0e3f832549cf65b8e75a53ac97aadb4f6a0.png",
      description: "“Teko lama” or traditional teapot is essentially used to brew water. The teapot is made of either silver, brass, or steel which makes the object very resistant through the test of time. It usually comes in various design. ",
      url: "Teko-Lama"
  },

  {
      name: "Bekas Lilin",
      img_src:"https://66.media.tumblr.com/8265e377a2ecd952f7ca9d6241ddcb3f/72033a24f9d4fd5c-b5/s540x810/500378bc678976770dfb03b774619ce520e8424e.png",
      description: "Bekas Lilin literally translates as candlestick. It is made of copper and usually has beautiful engravings. ",
      url:"bekas-lilin"
  },

  {
      name: "Jerunei ",
      img_src : " https://66.media.tumblr.com/bf36621e4ece990136c1b0399b776d5b/ad5cf72e564ac468-a7/s540x810/2a77c8d689fd9c0800e58ec46bb6b052846a3fb9.png",
      description:"Jerunei is a burial pole  or a resting place for desceased nobles in the olden days. It was built from large and mature Belian tree. Usually, few holes were dug onto the Jerunai pole. The middle and lower hole were where the body or remains of the deceased and their precious belonging were placed. Whereby, the hole on the top is where the sacrificial slaves would go. The design, carving motifs, and height of the Jerunei would vary as to represent the status of the deceased. Usually, the height of the Jerunai would range around 12-15 meter high.  ",
      url: "jerunei"
  },
  
  {
      name:"Pelita",
      img_src: " https://66.media.tumblr.com/de0d92aae8b7bf5f3d9f7242fd5d6299/72033a24f9d4fd5c-2f/s540x810/f206c9ca7005a84a676faa275ccc2c2a47b06f50.png",
      description: "Pelita is a traditional oil lamp made out of steel which would require gas oil to lit it up. It was used to illuminate the house or light up the way when walking at night. ",
      url:"pelita"
  },
]; 
